import BaseEnum from './base-enum';

export default BaseEnum.create({
  values: [
    // SearchMode_UNSPECIFIED (0) is the null value, and as such is
    // invalid.
    //
    // Note:
    // - We ensure this edge case doesn't propagate by normalizing the
    //   serialized response via the person serializer.

    // SearchMode_GRID (1) specifies that the person's default search mode
    // should be the original "Grid" view.
    { value: 1, label: 'Grid' },

    // SearchMode_LIST (2) specifies that the person's default search mode
    // should be the "List" view.
    { value: 2, label: 'List' },
  ],
});
